// 过滤器function
// 普通用户来源（）
export const govCharge = type => {
    type = type * 1;
    let str = "";
    switch (type) {
        case 1:
            str = "待审核";
            break;
        case 2:
            str = "通过";
            break;
        case 3:
            str = "不通过";
            break;
    }
    return str;
};
